import React from 'react'
import { FiMenu } from 'react-icons/fi'

export default function Header ({ title, userName, onToggleSidebar }) {
  return (
    <header className='admin-header'>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <button className='admin-hamburger' onClick={onToggleSidebar}>
          <FiMenu />
        </button>
        <h1 className='admin-header-title'>{title}</h1>
      </div>
      {userName && <span className='admin-header-user'>{userName}</span>}
    </header>
  )
}
